export default __webpack_public_path__ + "static/media/milita-side.066d48c9.png";